export const customTranslations = {
  prd: {},
  stg: {
    '8ade8ca6-b91b-4a7d-9912-1c7e944fddca-0': {
      resources: {
        orderR: {
          fields: {
            user: {
              name: '入居者氏名',
              nameKana: '入居者氏名(カナ)',
              phone: '入居者携帯電話番号(ハイフンなし)',
              email: '入居者メールアドレス'
            },
            contractor: {
              name: '電気契約者氏名',
              nameKana: '電気契約者氏名(カナ)',
              postalCode: '電気契約者郵便番号(ハイフンなし)',
              address: '電気契約者住所',
              phone: '電気契約者電話番号(ハイフンなし)',
              email: '電気契約者メールアドレス'
            },
            families: {
              name: '緊急連絡先氏名',
              nameKana: '緊急連絡先氏名(カナ)',
              phone: '緊急連絡先電話番号(ハイフンなし)',
              postalCode: '緊急連絡先郵便番号(ハイフンなし)'
            }
          }
        }
      }
    }
  },
  int: {},
  dev: {},
  exp: {}
}
